import * as React from 'react';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Item from '@mui/material/Grid';
import CloseIcon from '@mui/icons-material/Close';
export default function HorizontalLinearStepper(props) {
    const [activeStep, setActiveStep] = React.useState(0);
    const [skipped, setSkipped] = React.useState(new Set());
    const { steps, tutorialCompletedCallback, closeModelCallback } = props;



    const handleNext = () => {

        if (activeStep === steps.length - 1) {
            tutorialCompletedCallback();
            return;
        }
        console.log(activeStep);
        console.log(steps.length);
        setActiveStep((prevActiveStep) => prevActiveStep + 1);


    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };





    return (
        <Box sx={{ width: '100%' }}>
            <Button className="closeButton" onClick={() => closeModelCallback()} sx={{ mt: 1, mb: 1 }}><CloseIcon color='white' /></Button>
            <Stepper activeStep={activeStep}>
                {steps.map((step, index) => {
                    const stepProps = {};
                    const labelProps = {};

                    return (
                        <Step key={step.title} {...stepProps}>
                            <StepLabel {...labelProps}>{step.title}</StepLabel>
                        </Step>
                    );
                })}
            </Stepper>
            {activeStep === steps.length ? (
                <React.Fragment>

                </React.Fragment>
            ) : (

                <React.Fragment>

                    <Box sx={{marginTop: "15px"}}>
                    <Grid container spacing={2}>
                        <Grid spacing={0} item xs={6}>
                            <Box sx={{height: '100%'}} className="text-stepper-container">
                            <Typography className='stepper-name'>{steps[activeStep].name}</Typography>
                            <Typography className='stepper-description'>{steps[activeStep].description}</Typography>
                            {steps[activeStep].secondarydescription && 
                            <div className='subtext-stepper'>
                            {steps[activeStep].secondarydescription}
                            </div>}
                            </Box>
                        </Grid>
                        <Grid item xs={6}>
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <Grid item xs={12}>
                                        <div className='tutorial-main-img'>
                                            <Item>{steps[activeStep].mainimage}</Item>
                                        </div>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <div className='tutorial-secondary-img'>
                                            <Item>{steps[activeStep].secondaryimage}</Item>
                                        </div>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                    </Box>

                    <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
                        <Button
                            color="inherit"
                            disabled={activeStep === 0}
                            onClick={handleBack}
                            sx={{ mr: 1 }}
                        >
                            Atrás
                        </Button>
                        <Box sx={{ flex: '1 1 auto' }} />

                        <Button onClick={handleNext}>
                            {activeStep === steps.length - 1 ? 'Finalizar' : 'Siguiente'}
                        </Button>
                    </Box>
                </React.Fragment>
            )}
        </Box>
    );
}